import styled from "styled-components";
import {Typography} from "@material-ui/core";

export const AppInfoHeaderWrapper = styled.div`
  margin-bottom: 5px;
  display: flex;
`;

export const AppLogo = styled.img.attrs({
    alt: 'application logo',
})`
  max-width: 80px;
  max-height: 80px;
  align-self: center;
  margin-right: 20px;
  margin-top: 5px;
`;

export const HeaderTitle = styled(Typography).attrs({
    variant: 'h5',
})`
  font-size: 1.3rem !important;
  margin-bottom: 10px !important;
`;

export const HeaderDescription = styled(Typography)`
  font-style: italic;
  margin-bottom: 10px !important;
  text-align: justify;
`;
